import React, { useState, useEffect } from 'react';
import * as Utils from '../../../../../common/utils';
import * as Request from "../../../../../common/request";
import * as AMap from '../../../../../common/amap';

import './index.less';

const ActivityName = 'zjjPassengerInfo';


const PARKING_MAP = {
    '游客中心': {
        address: '上海市青浦区课植园路555号',
        lnglat: '121.050575,31.114525',
        totalParkingSpace: 167,
        openTime: '00:00—24:00'
    },
    '课植园路F1': {
        address: '上海市青浦区课植园路555号',
        lnglat: '121.050575,31.114525',
        totalParkingSpace: 150,
        openTime: '00:00—24:00'
    },
    '证大': {
        address: '上海市青浦区课植园路599弄',
        lnglat: '121.049149,31.113352',
        totalParkingSpace: 350,
        openTime: '00:00—24:00'
    },
    '影剧院广场': {
        address: '上海市青浦区新溪路18号',
        lnglat: '121.059435,31.109651',
        totalParkingSpace: 108,
        openTime: '00:00—24:00'
    },
    '乐湖': {
        address: '上海市青浦区东湖街340号',
        lnglat: '121.049828,31.103765',
        totalParkingSpace: 55,
        openTime: '00:00—24:00'
    },
    '中南朱里雅集': {
        address: '上海市青浦区油车浜路94号附近',
        lnglat: '121.058374,31.110956,',
        totalParkingSpace: 350,
        openTime: '00:00—24:00'
    },
    '新角里停车场': {
        address: '上海市青浦区新风路160号',
        lnglat: '121.058014,31.108629',
        totalParkingSpace: 260,
        openTime: '00:00—24:00'
    },
}

const PageModel = props => {

    const [list, seList] = useState([]);
    const [data, setData] = useState({});

    const [air, setAir] = useState('');
    const [text, setText] = useState('');//晴天 or 下雨
    const [temp, setTemp] = useState('');//温度
    const [windDir, setWindDir] = useState('');//风力


    const getAir = async () => {
        const result = await Request.get({
            url: '/air/now',
        });
        if (!result) return;
        if (result.data) {
            setAir(result.data.category);
        }
    }
    const getWeather = async () => {
        const result = await Request.get({
            url: '/weather/now',
        });
        if (!result) return;
        if (result.data) {
            setText(result.data.text);
            setTemp(result.data.temp);
            setWindDir(result.data.windDir);
        }
    };


    const getList = async () => {
        const result = await Request.get({
            url: '/zjj/parking/list'
        });
        if (!result) return;
        const list = result.data.info || [];
        seList(list);
    };

    const getData = async () => {
        const result = await Request.get({
            headers: { 'Activity-Name': ActivityName },
            url: '/zjj/passenger'
        });
        if (!result) return;

        if (result.data && result.data.info) {
            setData(result.data.info);
        }
    };

    useEffect(() => {
        getWeather();//天气信息
        getAir();//空气质量
        getList();//停车场信息
        getData();//人流信息
        Utils.setTitle('实时信息');
    }, [123]);


    return (
        <section className="h5parking-container" style={{ minHeight: window.innerHeight }}>
            <div className='h5parking-header'>
                <div className='h5parking-header-title'>朱家角古镇旅游区</div>
                <div className='h5parking-header-time'>{new Date().getMonth() + 1}月{new Date().getDate()}日| {text} {temp}° | {windDir}| {air}</div>
            </div>
            <div className='h5parking-content'>
                <div className='h5parking-content-title'>
                    <div className='h5parking-content-title-left'>景区当前游客数量:</div>
                    <div className='h5parking-content-title-right'>{data && data.keepNum || '-'} 人</div>
                </div>
                <div className='h5parking-content-list'>
                    <div className='h5parking-content-list-item'>
                        <div className='h5parking-content-list-item-left'>58313人</div>
                        <div className='h5parking-content-list-item-right'>单日全天最大承载量</div>
                    </div>

                    <div className='h5parking-content-list-item'>
                        <div className='h5parking-content-list-item-left'>18077人</div>
                        <div className='h5parking-content-list-item-right'>瞬时接待最大承载量</div>
                    </div>

                    <div className='h5parking-content-list-item'>
                        <div className='h5parking-content-list-item-left'>{data && data.enterSum || '-'}</div>
                        <div className='h5parking-content-list-item-right'>当前时间为止进入总人数</div>
                    </div>
                </div>
            </div>
            <div className='h5parking-bottom'>
                <div className='h5parking-bottom-title'>停车场信息</div>
                <div className='h5parking-bottom-list'>
                    {
                        list && list.length > 0 && list.map((item, idx) => {
                            const _parkingItem = PARKING_MAP[item.parkingName];
                            if (!_parkingItem) return null;

                            const name = item.parkingName + (item.parkingName && item.parkingName.indexOf('停车场') == -1 && '停车场' || '');
                            let radio = ((item.parkingRemaining < 0 ? 0 : item.parkingRemaining) / _parkingItem.totalParkingSpace * 100).toFixed(2);
                            radio = Math.min(radio, 100);
                            return (
                                <div className='h5parking-bottom-list-item' key={idx}>
                                    <div className='h5parking-bottom-list-item-left'>
                                        <div className='h5parking-bottom-list-item-left-title'>{name}</div>
                                        <div className='h5parking-bottom-list-item-left-address' onClick={async () => {
                                            const res = await AMap.getCurrentPosition2();
                                            let startAddress = '';
                                            let startLngLat = '';
                                            if (res.formattedAddress && res.lnglat) {
                                                startAddress = res.formattedAddress;
                                                startLngLat = res.lnglat.join(',');
                                            }
                                            const link = `https://gaode.com/dir?from[name]=${startAddress}&from[lnglat]=${startLngLat}&to[name]=${_parkingItem.address}&to[lnglat]=${_parkingItem.lnglat}&policy=1&type=car`;
                                            window.location.href = link;
                                            return;

                                        }}>
                                            <img src={require('./daohang.png')} alt="" />
                                        </div>
                                    </div>
                                    <div className='h5parking-bottom-list-item-right'>{_parkingItem.address}</div>
                                    <div className='h5parking-bottom-list-item-right-jindu'><span style={{ width: radio + '%' }} /></div>
                                    <div className='h5parking-bottom-list-item-right-item'>
                                        <div className='h5parking-bottom-list-item-right-left'>剩余总数/车位总数</div>
                                        <div className='h5parking-bottom-list-item-right-rigth'>{item.parkingRemaining < 0 ? 0 : item.parkingRemaining}个/{_parkingItem.totalParkingSpace}个</div>
                                    </div>
                                </div>
                            )
                        })
                    }
                </div>
            </div>
            <div className='h5parking-bottom-img'>
                <img src={require('./bottom.png')} alt="" />
            </div>
        </section>
    );
};

export default PageModel;
